export enum HotKeys {
  MAIN_MENU = "m",
  NOTIFICATION_MENU = "n",
  ACTIVITY_LIST_DROP_DOWN = "a",
  ACTIVITY_LIST_TABLE = "f",
  RUN_ACTIVITY = "alt+r",
  SIDE_MENU = "s",
}
